var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { assertUserTypeOptional } from "healthex-common/checkusertype";
import { UserType } from "healthex-common/user.dtos";
import { computed, observable, when } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { SimpleDialogModel } from "../SimpleDialogModel";
export class GlobalAdminHealthcareOrganizationLoginSettingsViewModel {
    constructor(opts) {
        this.ssoConfiguration = this.getDefaultSSOConfigurationInput();
        this.organization = NOT_LOADED;
        this.editing = false;
        this.isSSOLoginSelected = undefined;
        this.domain = undefined;
        this.switchToPasswordConfirmationDialogModel = new SimpleDialogModel();
        this.organizationsManager = opts.container.organizationsManager;
        this.globalAdminUIManager = opts.container.globalAdminUIManager;
        this.organizationId = opts.container.globalAdminUIManager.organizationIdToAdmin;
        when(() => this.organization === NOT_LOADED, () => this.loadHealthcareOrganization());
    }
    get allowEditing() {
        return this.globalAdminUIManager.loginSettingsAreEditable;
    }
    get showSSOConfig() {
        if (this.organization === NOT_LOADED)
            return false;
        return this.isSSOLoginSelected;
    }
    get showSSORequirement() {
        var _a;
        if (this.organization === NOT_LOADED)
            return false;
        return !((_a = this.organization) === null || _a === void 0 ? void 0 : _a.ssoEnabled);
    }
    get organizationPasswordConfiguration() {
        var _a;
        if (this.organization === NOT_LOADED)
            return null;
        return (_a = this.organization) === null || _a === void 0 ? void 0 : _a.passwordConfiguration;
    }
    async updateLoginSetting(input) {
        if (input.samlSSO) {
            this.isSSOLoginSelected = true;
            this.loadSSOConfiguration();
        }
        else {
            const confirmed = await this.switchToPasswordConfirmationDialogModel.showAndWait();
            if (confirmed) {
                this.isSSOLoginSelected = false;
                this.ssoConfiguration = this.getDefaultSSOConfigurationInput();
            }
        }
    }
    updateSSOConfig(update) {
        if (this.organization === NOT_LOADED)
            return;
        this.ssoConfiguration.idpAttributes = { ...this.ssoConfiguration.idpAttributes, ...update };
    }
    updateidpMetadataUrl(value) {
        this.ssoConfiguration.idpMetadataUrl = value;
    }
    updateSSOProviderName(value) {
        this.ssoConfiguration.ssoProviderName = value;
    }
    updateDomain(value) {
        this.domain = value;
    }
    edit() {
        this.editing = true;
    }
    async save() {
        var _a;
        if (this.organization === NOT_LOADED || !this.organization)
            return;
        const updatedOrganizationDetailsInput = {
            type: UserType.HEALTHCARE_ORGANIZATION,
            domain: this.isSSOLoginSelected ? (_a = this.domain) !== null && _a !== void 0 ? _a : "" : "",
            ssoEnabled: this.isSSOLoginSelected ? this.isSSOLoginSelected : false,
            ssoConfiguration: this.isSSOLoginSelected ? this.ssoConfiguration : undefined,
        };
        await this.organizationsManager.updateOrganizationDetails(this.organization.id, updatedOrganizationDetailsInput);
        this.editing = false;
        await this.loadHealthcareOrganization();
    }
    cancel() {
        this.editing = false;
        this.loadSSOConfiguration();
    }
    loadSSOConfiguration() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (this.organization !== NOT_LOADED && this.organization) {
            this.ssoConfiguration = {
                ssoProviderName: (_b = (_a = this.organization.ssoConfiguration) === null || _a === void 0 ? void 0 : _a.ssoProviderName) !== null && _b !== void 0 ? _b : "",
                idpMetadataUrl: (_d = (_c = this.organization.ssoConfiguration) === null || _c === void 0 ? void 0 : _c.idpMetadataUrl) !== null && _d !== void 0 ? _d : "",
                idpAttributes: {
                    email: (_f = (_e = this.organization.ssoConfiguration) === null || _e === void 0 ? void 0 : _e.idpAttributes.email) !== null && _f !== void 0 ? _f : "",
                    firstName: (_h = (_g = this.organization.ssoConfiguration) === null || _g === void 0 ? void 0 : _g.idpAttributes.firstName) !== null && _h !== void 0 ? _h : "",
                    lastName: (_k = (_j = this.organization.ssoConfiguration) === null || _j === void 0 ? void 0 : _j.idpAttributes.lastName) !== null && _k !== void 0 ? _k : "",
                    title: (_m = (_l = this.organization.ssoConfiguration) === null || _l === void 0 ? void 0 : _l.idpAttributes.title) !== null && _m !== void 0 ? _m : undefined,
                    permissions: (_p = (_o = this.organization.ssoConfiguration) === null || _o === void 0 ? void 0 : _o.idpAttributes.permissions) !== null && _p !== void 0 ? _p : undefined,
                    phone: (_r = (_q = this.organization.ssoConfiguration) === null || _q === void 0 ? void 0 : _q.idpAttributes.phone) !== null && _r !== void 0 ? _r : undefined,
                },
            };
            this.domain = this.organization.domain;
        }
    }
    getDefaultSSOConfigurationInput() {
        return {
            ssoProviderName: "",
            idpMetadataUrl: "",
            idpAttributes: {
                email: "",
                firstName: "",
                lastName: "",
                title: undefined,
                permissions: undefined,
                phone: undefined,
            },
        };
    }
    async loadHealthcareOrganization() {
        if (!this.organizationId)
            return;
        const dataOrginatorOrg = assertUserTypeOptional(await this.organizationsManager.loadOrganization(this.organizationId), UserType.HEALTHCARE_ORGANIZATION);
        if (dataOrginatorOrg) {
            this.organization = dataOrginatorOrg;
            this.isSSOLoginSelected = dataOrginatorOrg.ssoEnabled;
            if (dataOrginatorOrg.ssoEnabled) {
                this.loadSSOConfiguration();
            }
        }
    }
}
__decorate([
    observable
], GlobalAdminHealthcareOrganizationLoginSettingsViewModel.prototype, "ssoConfiguration", void 0);
__decorate([
    observable
], GlobalAdminHealthcareOrganizationLoginSettingsViewModel.prototype, "organization", void 0);
__decorate([
    observable
], GlobalAdminHealthcareOrganizationLoginSettingsViewModel.prototype, "editing", void 0);
__decorate([
    observable
], GlobalAdminHealthcareOrganizationLoginSettingsViewModel.prototype, "isSSOLoginSelected", void 0);
__decorate([
    observable
], GlobalAdminHealthcareOrganizationLoginSettingsViewModel.prototype, "domain", void 0);
__decorate([
    computed
], GlobalAdminHealthcareOrganizationLoginSettingsViewModel.prototype, "allowEditing", null);
__decorate([
    computed
], GlobalAdminHealthcareOrganizationLoginSettingsViewModel.prototype, "showSSOConfig", null);
__decorate([
    computed
], GlobalAdminHealthcareOrganizationLoginSettingsViewModel.prototype, "showSSORequirement", null);
__decorate([
    computed
], GlobalAdminHealthcareOrganizationLoginSettingsViewModel.prototype, "organizationPasswordConfiguration", null);
